var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M14.8 23.6v-4.4C14.8 11.918 17 6 28 6s13.2 5.918 13.2 13.2v4.4M39 50H17C8.2 50 6 47.8 6 39v-4.4c0-8.8 2.2-11 11-11h22c8.8 0 11 2.2 11 11V39c0 8.8-2.2 11-11 11Z"
  })));
};
export default SvgLock;